
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12.9091V10.6364L19.0473 10.2336C18.8737 9.54061 18.598 8.87728 18.2291 8.26545L20.0327 5.89273L18.1073 3.96455L15.7345 5.76818C15.1227 5.39929 14.4594 5.12354 13.7664 4.95L13.3636 2H10.6364L10.2336 4.95273C9.54061 5.12627 8.87728 5.40202 8.26545 5.77091L5.89273 3.96455L3.96455 5.89273L5.76818 8.26545C5.39929 8.87728 5.12354 9.54061 4.95 10.2336L2 10.6364V12.9091H7.86385V12.9091V14.5202L5.65939 16.7247L5.61013 16.7739C5.34868 16.6284 5.04758 16.5455 4.72712 16.5455C3.72296 16.5455 2.90894 17.3595 2.90894 18.3637C2.90894 19.3678 3.72296 20.1818 4.72712 20.1818C5.73127 20.1818 6.5453 19.3678 6.5453 18.3637C6.5453 18.0434 6.4625 17.7425 6.31713 17.4811L6.36649 17.4318L8.7174 15.0809L8.86385 14.9344V14.7273V12.9091V12.9091H11.5V12.9091V18.3637V18.4332C10.7389 18.6504 10.1816 19.351 10.1816 20.1818C10.1816 21.186 10.9957 22 11.9998 22C13.004 22 13.818 21.186 13.818 20.1818C13.818 19.3511 13.2609 18.6506 12.5 18.4333V18.3637V12.9091V12.9091H15.1362V12.9091V14.7273V14.9344L15.2827 15.0809L17.6336 17.4318L17.6828 17.481C17.5374 17.7424 17.4546 18.0433 17.4546 18.3637C17.4546 19.3678 18.2686 20.1818 19.2728 20.1818C20.2769 20.1818 21.091 19.3678 21.091 18.3637C21.091 17.3595 20.2769 16.5455 19.2728 16.5455C18.9524 16.5455 18.6513 16.6284 18.3899 16.7738L18.3407 16.7247L16.1362 14.5202V12.9091V12.9091H22Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowapiFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
